// Teams views
import Teams from '@/views/Teams.vue';
import TeamsList from '@/views/Teams/TeamsList.vue';
import TeamInfo from '@/views/Teams/TeamInfo.vue';
import TeamsUsers from '@/views/Teams/Info/Users.vue';
import TeamsPermissions from '@/views/Teams/Info/Permissions.vue';
import UserCard from '@/views/Teams/UserCard.vue';
import UserInfo from '@/views/Teams/User/UserInfo.vue';

export default [
  {
    path: '/teams',
    name: 'teams',
    component: Teams,
    meta: {
      requiresAuth: true,
      view: 'teams',
    },
    children: [
      {
        path: 'all',
        component: TeamsList,
        name: 'teams.all',
        meta: {
          view: 'teamsList',
        },
        children: [
          {
            path: 'details',
            component: TeamInfo,
            name: 'teams.all.details',
            meta: {
              view: 'TeamInfo',
            },
            children: [
              {
                path: 'users',
                component: TeamsUsers,
                name: 'teams.all.details.all-users',
                meta: {
                  view: 'users',
                },
              },
              {
                path: 'permissions',
                component: TeamsPermissions,
                name: 'teams.all.details.all-permissions',
                meta: {
                  view: 'permissions',
                },
              },
            ],
          },
        ],
      },
      {
        path: ':id',
        component: TeamsList,
        name: 'teams.teams-list',
        meta: {
          view: 'teamsList',
        },
        children: [
          {
            path: 'details',
            component: TeamInfo,
            name: 'teams.teams-list.details',
            meta: {
              view: 'TeamInfo',
            },
            children: [
              {
                path: 'users',
                component: TeamsUsers,
                name: 'teams.teams-list.details.users',
                meta: {
                  view: 'users',
                },
              },
              {
                path: 'permissions',
                component: TeamsPermissions,
                name: 'teams.teams-list.details.permissions',
                meta: {
                  view: 'permissions',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'user/:id',
        component: UserCard,
        name: 'teams.user',
        children: [
          {
            path: 'info',
            component: UserInfo,
            name: 'teams.user.user-info',
            meta: {
              view: 'info',
            },
          },
        ],
      },
      {
        path: '',
        name: 'teams.empty',
        redirect: {
          name: 'teams.all.details.all-users',
        },
      },
      {
        path: ':catchAll(.*)',
        name: 'teams.catch-all',
        redirect: {
          name: 'teams.all.details.all-users',
        },
      },
    ],
  },
];
